module.exports = __webpack_public_path__ + "img/4-vidio.4af55b66.jpg";